import { ShowFrontPage as DLShowFrontPage, StartGame as DLStartGame, OpenBriefcase as DLOpenBriefcase, ResetGame as DLResetGame, ContinueGame as DLContinueGame } from './../DL/Briefcase';
import SignalRService from '../WS/SignalRService';

let briefcaseAdminMessageHandler = null;
let briefcaseAdminReconnectedHandler = null;
let briefcasePlayerMessageHandler = null;
let briefcasePlayerReconnectedHandler = null;

const ConnectWebSocketForBriefcaseAdmin = (onIncomingMessage, onStatusChange = () => {}) => {
    onStatusChange('connecting');

    briefcaseAdminMessageHandler = (envelope) => {
        if (envelope && envelope.type && envelope.type.toLowerCase().startsWith('briefcase.')) {
            onIncomingMessage(envelope);
        }
    };

    briefcaseAdminReconnectedHandler = () => {
        onStatusChange('connected');
    };

    SignalRService.on('message', briefcaseAdminMessageHandler);
    SignalRService.on('reconnected', briefcaseAdminReconnectedHandler);

    SignalRService.connect({ tipo: 'superadmin' })
        .then(() => {
            onStatusChange('connected');
        })
        .catch(() => {
            onStatusChange('error');
        });
};

const DisconnectWebSocketForBriefcaseAdmin = () => {
    if (briefcaseAdminMessageHandler) {
        SignalRService.off('message', briefcaseAdminMessageHandler);
        briefcaseAdminMessageHandler = null;
    }
    if (briefcaseAdminReconnectedHandler) {
        SignalRService.off('reconnected', briefcaseAdminReconnectedHandler);
        briefcaseAdminReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

const ShowBriefcaseFrontPage = async () => {
    return await DLShowFrontPage();
};

const StartBriefcaseGame = async (configurationData) => {
    try {
        if (!configurationData) return { success: false, message: 'Configuración inválida.' };
        if (configurationData.totalBriefcases < 2 || configurationData.totalBriefcases > 50) {
            return { success: false, message: 'La cantidad de maletines debe estar entre 2 y 50.' };
        }
        if (configurationData.suspenseDurationMs < 0) {
            return { success: false, message: 'El tiempo de suspenso no puede ser negativo.' };
        }

        const rawPrizesList = configurationData.prizesListString || "";
        const cleanPrizesArray = rawPrizesList.split(',').map(prize => prize.trim());
        
        const finalConfiguration = {
            totalBriefcases: configurationData.totalBriefcases,
            suspenseDurationMs: configurationData.suspenseDurationMs,
            gameMode: configurationData.gameMode,
            winningAttempt: configurationData.winningAttempt,
            specialPrize: configurationData.specialPrize,
            prizes: cleanPrizesArray
        };

        const response = await DLStartGame(finalConfiguration);
        return response;
    } catch (error) {
        return { success: false, message: 'Excepción en BL al iniciar el juego de maletines.' };
    }
};

const OpenTargetBriefcase = async (briefcaseIdentifier) => {
    if (!briefcaseIdentifier || briefcaseIdentifier <= 0) {
        return { success: false, message: 'Identificador de maletín no válido.' };
    }
    return await DLOpenBriefcase(briefcaseIdentifier);
};

const ResetBriefcaseGame = async () => {
    return await DLResetGame();
};

const ContinueBriefcaseGame = async () => {
    return await DLContinueGame();
};

const ConnectBriefcaseWebSocket = async (onStatus = () => {}, onToast = () => {}) => {
    onStatus('connecting');

    briefcasePlayerReconnectedHandler = () => {
        onStatus('connected');
    };

    SignalRService.on('reconnected', briefcasePlayerReconnectedHandler);

    SignalRService.connect({ tipo: 'briefcase:aficionado' })
        .then(() => {
            onStatus('connected');
            onToast('Conectado');
        })
        .catch(() => {
            onStatus('error');
        });
};

const SetBriefcaseSocketMessageHandler = (handler) => {
    if (briefcasePlayerMessageHandler) {
        SignalRService.off('message', briefcasePlayerMessageHandler);
    }

    briefcasePlayerMessageHandler = (envelope) => {
        handler(envelope);
    };

    SignalRService.on('message', briefcasePlayerMessageHandler);
};

const ClearBriefcaseSocketMessageHandler = () => {
    if (briefcasePlayerMessageHandler) {
        SignalRService.off('message', briefcasePlayerMessageHandler);
        briefcasePlayerMessageHandler = null;
    }
};

const DisconnectBriefcaseWebSocket = () => {
    if (briefcasePlayerMessageHandler) {
        SignalRService.off('message', briefcasePlayerMessageHandler);
        briefcasePlayerMessageHandler = null;
    }
    if (briefcasePlayerReconnectedHandler) {
        SignalRService.off('reconnected', briefcasePlayerReconnectedHandler);
        briefcasePlayerReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

const SendMainBriefcaseSelection = async (briefcaseId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Player/SelectMain`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ briefcaseId: briefcaseId })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

const SendTargetBriefcase = async (briefcaseId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Player/TargetNext`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ briefcaseId: briefcaseId })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

export { ConnectWebSocketForBriefcaseAdmin, DisconnectWebSocketForBriefcaseAdmin, ShowBriefcaseFrontPage, StartBriefcaseGame, OpenTargetBriefcase, ResetBriefcaseGame, ContinueBriefcaseGame, ConnectBriefcaseWebSocket, SetBriefcaseSocketMessageHandler, ClearBriefcaseSocketMessageHandler, DisconnectBriefcaseWebSocket, SendMainBriefcaseSelection, SendTargetBriefcase };